import React from 'react';
import './Input.css';

export default function Input({
  label,
  error,
  helperText,
  options = null,
  className = '',
  ...props
}) {
  const inputId = props.id || `input-${Math.random().toString(36).substr(2, 9)}`;
  const hasError = !!error;
  const type = props.type || 'text';

  return (
    <div className={`input-group ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
          {props.required && <span className="input-required">*</span>}
        </label>
      )}
      {options ? (
        <select
          id={inputId}
          className={`input ${hasError ? 'input-error' : ''}`}
          {...props}
        >
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          id={inputId}
          className={`input ${hasError ? 'input-error' : ''}`}
          {...props}
        />
      ) : (
        <input
          id={inputId}
          type={type}
          className={`input ${hasError ? 'input-error' : ''}`}
          {...props}
        />
      )}
      {error && <div className="input-error-message">{error}</div>}
      {helperText && !error && <div className="input-helper">{helperText}</div>}
    </div>
  );
}

